import {action, computed} from '@api'
import {PDFTemplateName} from '@modules/pdf'
import {aws, CentricUserName, globalStores, ICatalogUserSettings, StoresInstance} from '@stores'
import {strings} from '@stores/StringsStore'

/**
 * Some subset of {@see ICatalogUserSettings}
 */
export type PDFStringifiedCatalogSettings = string

/**
 * Stringified PDF input json pertinent to the template
 *
 * Example for RH pdf:
 * """{"expanded":false,"heroCards":{"overrides":{"combinedShapes":[],"fullWidth":{},"orders":{},"subdivide":{}},"secondLevel":{"selections":{"Panel Platform Bed":{"selected":0},"Panel Canopy Bed":{"selected":0},"Open Nightstand":{"selected":0},"Closed Nightstand":{"selected":0},"Low & Tall Dresser":{"selected":0},"empty-placeholder-5":{"selected":0},"empty-placeholder-6":{"selected":0},"unassigned":{"selected":0}}},"show":true,"showAll":true},"perspective":null,"swatches":{"selected":null}}"""
 */
export type PDFStringifiedInput = string
/**
 * The _id of a row in vip-pdf-artifact
 */
export type PDFArtifactID = string

export interface ICloudPDFEntry {
  _id: string

  s3Key: string

  filename?: string

  /**
   * Stringified input that generated the query
   */
  input: PDFStringifiedInput

  /**
   * Stringified catalog settings used by the template
   */
  settings: PDFStringifiedCatalogSettings

  timestamp?: number

  userId?: CentricUserName

  template?: PDFTemplateName

  pages: number
  fileSize: number
}

export class CloudPDFEntry {
  constructor(public entry: ICloudPDFEntry, public stores: StoresInstance) {}

  get timestamp() { return this.entry.timestamp}

  get template() { return this.entry.template}

  get userId() { return this.entry.userId}

  get users() { return this.stores.users}

  @computed get label() {
    const {users, entry, timestampAsDate} = this
    return `${users.getById(entry.userId)?.name ?? strings.emptyLabel} - ${timestampAsDate.toLocaleDateString()}`
  }

  @computed get timestampAsDate() {
    return new Date(this.entry.timestamp)
  }

  @computed get user() {
    return globalStores.users.getById(this.userId)
  }

  @computed get input(): any {
    return JSON.parse(this.entry.input)
  }

  @computed get settings(): Partial<ICatalogUserSettings> {
    return JSON.parse(this.entry.settings)
  }

  @computed get url() {
    const {entry: {s3Key}} = this, {urlFor} = aws

    return urlFor(s3Key)
  }
}



// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/CloudPDFEntry.ts